(function() {
    var m = angular.module('utils');

    m.directive('help', [function() {
        return {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {

            }
        }
    }]);
})();
